/** Uniform display format: `NOM Prénom` (surname uppercased). Derived, never stored by hand. */
export function formatDisplayName(firstName: string, lastName: string): string {
  return `${lastName.toUpperCase()} ${firstName}`.trim();
}

/**
 * Best-effort split: last whitespace-delimited token = surname, the rest = first name.
 * Correct for "Prénom NOM" (FR) and "Given Surname" (CN romanised) inputs.
 * Compound surnames (e.g. "SANTILLAN ORTIZ") land wrong and are fixed by an admin afterwards.
 */
export function splitName(raw: string): { firstName: string; lastName: string } {
  const tokens = raw.trim().split(/\s+/).filter(Boolean);
  if (tokens.length <= 1) return { firstName: raw.trim(), lastName: '' };
  const lastName = tokens.pop() as string;
  return { firstName: tokens.join(' '), lastName };
}
